import { useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import { DateTime } from 'luxon';

import { Article, Issue } from '../../../constants';

import styles from './Collection.module.css';
import { Topbar } from '../../../components/preview/Preview';
import { Loading } from '../../../components/loading/Loading';

import { TrackingContext } from '../../../tracking/Tracking.context';
import { CollectionContext } from './Collection.context';
import { useGetCollection } from './Collection.hooks';

export function CollectionView() {
	return (
		<div className={styles['container']}>
			<View />
		</div>
	);
}

function View() {
	const { id } = useParams();
	const { isLoading, error, issue } = useGetCollection(`${id}`);

	if (isLoading || issue === undefined || issue === null) {
		return (
			<div className={styles['view']}>
				<Topbar />
				<div className={styles['loading']}>
					<Loading />
				</div>
			</div>
		);
	}

	if (error) {
		return (
			<div className={styles['view']}>
				<Topbar />
				<div className={styles['error']}>
					<h1>{error.message}</h1>
				</div>
			</div>
		);
	}

	return (
		<CollectionContext.Provider value={{ issue }}>
			<div className={styles['view']}>
				<Topbar url={`/?section=collections`} />
				<Content {...issue} />
			</div>
		</CollectionContext.Provider>
	);
}

function Content(issue: Issue) {
	const { name, description, articles } = issue;
	if (!articles) {
		return null;
	}

	return (
		<div className={styles['content']}>
			<h1>{name}</h1>
			<h2>{description}</h2>
			<div className={styles['issues']}>
				{articles.map((a) => (
					<Item key={a.id} {...a} />
				))}
			</div>
		</div>
	);
}

function Item(article: Article) {
	console.log(`Article: `, article);
	const { sendEvent } = useContext(TrackingContext);
	const { issue } = useContext(CollectionContext);
	const { id, slug, name, thumbnail, releaseDate } = article;
	const from = `${window.location.pathname}`;
	if (!issue) {
		return null;
	}
	const url = `/issues/${issue.slug ?? issue.id}/${slug ?? id}`;
	return (
		<div className={styles['issue']}>
			<Link
				to={url}
				state={{ from }}
				onClick={() => {
					sendEvent({
						type: 'BTN_CLICK_ISSUE',
						data: {
							issue: {
								id: parseInt(`${id}`, 10),
								slug,
							},
						},
					});
				}}
			>
				<div className={styles['image']}>
					{thumbnail ? (
						<img src={thumbnail} alt={'Thumbnail'} />
					) : (
						<div />
					)}
				</div>
				<div className={styles['title']}>
					<h3>{name['en']}</h3>
				</div>
				<div className={styles['content']}>
					<small>
						{DateTime.fromISO(releaseDate).toFormat(
							'LLLL dd, yyyy',
						)}
					</small>
				</div>
			</Link>
		</div>
	);
}
